import { render, staticRenderFns } from "./collpaseNav.vue?vue&type=template&id=b6aae3e6&scoped=true"
import script from "./collpaseNav.vue?vue&type=script&lang=js"
export * from "./collpaseNav.vue?vue&type=script&lang=js"
import style0 from "./collpaseNav.vue?vue&type=style&index=0&id=b6aae3e6&prod&scoped=true&lang=less"
import style1 from "./collpaseNav.vue?vue&type=style&index=1&id=b6aae3e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6aae3e6",
  null
  
)

export default component.exports